import { render, staticRenderFns } from "./content-panel.vue?vue&type=template&id=b046dc86&scoped=true&"
import script from "./content-panel.vue?vue&type=script&lang=js&"
export * from "./content-panel.vue?vue&type=script&lang=js&"
import style0 from "./content-panel.vue?vue&type=style&index=0&id=b046dc86&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b046dc86",
  null
  
)

export default component.exports